import { combineReducers } from 'redux'
import merchant, { LoadingMerchant } from '../Header/reducer'
import loginForm from '../Account/reducers/loginForm'
import user from '../Account/reducers/token'
import forgotPassword from '../Account/reducers/forgotPassword'
import merchantCountries from '../Account/reducers/countries'
import profile from '../MyProfile/reducer'
import password from '../ChangePassword/reducer'
import orders from '../Orders/reducers'
import address from '../Address/reducers'
import buyerWishlist from '../Wishlist/reducers'
import actionFeedback from '../shared/actionFeedback/reducer'

const rootReducer = combineReducers({
  LoadingMerchant,
  merchant,
  user,
  merchantCountries,
  loginForm,
  forgotPassword,
  profile,
  password,
  orders,
  address,
  actionFeedback,
  buyerWishlist,
})

export default rootReducer
